import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

/**
 * Tracks whether 2FA verification is currently pending
 * - true: User logged in with email/password but hasn't completed 2FA yet
 * - false: Either no 2FA required, or 2FA verification completed
 *
 * Used to skip GraphQL queries during 2FA flow to avoid 403 errors in console
 * Persisted to sessionStorage to survive page refreshes and prevent bypass attempts
 */
export const twoFaVerificationPendingState = atom({
  key: "twoFaVerificationPendingState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom], // Persist to sessionStorage
});
